import { connect } from 'react-redux';
import { compose, withHandlers, mapProps } from 'recompose';

import { formatTalentsData } from '../../utils';
import { openModal, modalNames } from '../../modals';
import TalentsList from '../../components/talents-list';
import { handleRemoveRequestTalent } from '../../redux/thunk/requests';


export default compose(
  connect(null, { openModal, handleRemoveRequestTalent }),
  withHandlers({
    handleTalentDelete: props => (requestId, talentId) => {
      props.handleRemoveRequestTalent(requestId, talentId);
    },
    openManageTalentsModal: actions => requestId =>
      actions.openModal({
        name: modalNames.MANAGE_REQUEST_TALENTS,
        payload: {
          requestId,
        },
      }),
  }),
  mapProps(({ talents, ...rest }) => ({
    talents: formatTalentsData(talents),
    ...rest,
  })),
)(TalentsList);



// WEBPACK FOOTER //
// ./src/containers/talents-simple-list/index.js